import React from 'react';
import { FileCheck, Phone, FileSearch } from 'lucide-react';
export function LegalServicesSection({
  onRequestCall
}) {
  const handleServiceAction = service => {
    console.log(`Selected service: ${service}`);
    // This would handle the specific service action
  };
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-260">
      <ServiceCard icon={<FileCheck className="w-6 h-6 text-teal-500" data-id="element-262" />} title="Will Creation" description="Create a legally binding will" featureDescription="Our guided process helps you create a comprehensive, legally valid will. Protect your assets and ensure your wishes are carried out." price="$599" actionLabel="Start Your Will Today" onAction={() => handleServiceAction('Will Creation')} data-id="element-261" />
      <ServiceCard icon={<Phone className="w-6 h-6 text-teal-500" data-id="element-264" />} title="Call with Lawyer" description="Schedule a call with a lawyer" featureDescription="Connect directly with a specialized lawyer for personalized legal assistance. Discuss your specific situation and get expert guidance." price="$149" actionLabel="Request Call" onAction={onRequestCall} data-id="element-263" />
      <ServiceCard icon={<FileSearch className="w-6 h-6 text-teal-500" data-id="element-266" />} title="Document Review" description="Have your documents reviewed by a lawyer" featureDescription="Professional review of contracts, agreements, and legal documents. Receive detailed feedback and suggestions for improvements." price="$199" actionLabel="Start Now" onAction={() => handleServiceAction('Document Review')} data-id="element-265" />
    </div>;
}
function ServiceCard({
  icon,
  title,
  description,
  featureDescription,
  price,
  actionLabel,
  onAction
}) {
  return <div className="bg-white border border-gray-100 rounded-lg p-4 hover:shadow-md transition-shadow relative cursor-pointer" onClick={onAction} data-id="element-267">
      {price && <span className="absolute top-2 right-2 bg-purple-100 text-purple-800 text-xs font-semibold px-2 py-1 rounded" data-id="element-268">
          {price}
        </span>}
      <div className="mt-4" data-id="element-269">
        <div className="p-2 bg-teal-50 rounded-lg inline-block mb-3" data-id="element-270">
          {icon}
        </div>
        <h3 className="font-medium" data-id="element-271">{title}</h3>
        <p className="text-sm text-gray-500 mb-1" data-id="element-272">{description}</p>
        <p className="text-xs text-gray-400 mb-3" data-id="element-273">{featureDescription}</p>
        {actionLabel && <button onClick={e => {
        e.stopPropagation();
        onAction();
      }} className="mt-2 text-sm text-teal-600 font-medium hover:text-teal-800 cursor-pointer" data-id="element-274">
            {actionLabel} {'->'}
          </button>}
      </div>
    </div>;
}